/** @description Очищает значения стиля для курсора
 * @param ref {React.RefObject<HTMLDivElement>} ссылка на элемент
 * @return {void}
 */
export var cleanCursorStyles = function cleanCursorStyles(ref) {
  document.body.style.cursor = 'default';

  /* istanbul ignore next */
  if (ref.current) {
    ref.current.style.cursor = 'default';
  }
};